module.exports = __webpack_public_path__ + "static/media/1get.f69ccdd4.svg";